import { IEmailLoggable } from '@services/strategy-pattern-login/iEmail-loggable';
import { ISuitabilityLoggable } from './strategy-pattern-login/iSuitability-loggable';
import { INewsLoggable } from './strategy-pattern-login/iNews-loggable';
import { INegotiationWso2Service } from './webFeeder/iNegotiation-wso2.service';
import { INegotiationApiService } from './webFeeder/iNegotiation-api.service';
import { INegotiationLoggable } from './strategy-pattern-login/iNegotiation-loggable';
import { Injectable } from '@angular/core';
import { Constants } from '@utils/constants';
import { ConfigService } from './webFeeder/config.service';

import { IQuotesApiService } from './webFeeder/iQuotes-api.service';
import { IQuotesWso2Service } from './webFeeder/iQuotes-wso2.service';
import { IQuoteLoggable } from './strategy-pattern-login/iQuote-loggable';
import { INewsWso2Service } from './webFeeder/iNews-wso2.service';
import { INewsApiService } from './webFeeder/iNews-api.service';
import { IDufusionLoggable } from './strategy-pattern-login/iDifusion-loggable';
import { IDifusionApiService } from './webFeeder/iDifusion-api.service';
import { IDifusionWso2Service } from './webFeeder/iDifusion-wso2.service';
import { ICedroServicesLoggable } from './strategy-pattern-login/iCedroServices-loggable';
import { ICedroServicesApiService } from './webFeeder/iCedro-services-api.service';
import { ICedroServicesWso2Service } from './webFeeder/iCedro-services-wso2.service';
import { ISuitabilityWso2Service } from './webFeeder/iSuitability-wso2.service';
import { ISuitabilityAdapterService } from './webFeeder/iSuitability-adapter.service';
import { ISuitabilityApiService } from './webFeeder/iSuitability-api.service';
import { IEletronicSignatureWso2Service } from './webFeeder/iEletronic-signature-wso2.service';
import { IEletronicSignatureApiService } from './webFeeder/iEletronic-signature-api.service';
import { IEletronicSignatureAdapterService } from './webFeeder/iEletronic-signature-adapter.service';
import { IEletronicSignature } from './strategy-pattern-login/iEletronic-Signature';
import { IEmailFacadeService } from './webFeeder/iEmail-facade.service';
import { IEmailWso2Service } from './webFeeder/iEmail-wso2.service';
import { IEmailAdapterService } from './webFeeder/iEmail-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class AuthServer {

  public iQuote: IQuoteLoggable;
  public iNegotiation: INegotiationLoggable;
  public iNews: INewsLoggable;
  public iDifusion: IDufusionLoggable;
  public iCedroServices: ICedroServicesLoggable;
  public iSuitabilityService: ISuitabilityLoggable;
  public iEletronicSignature: IEletronicSignature;
  public iEmailServices: IEmailLoggable;

  constructor(
    private _configService: ConfigService,
    private _iQuotesApiService: IQuotesApiService,
    private _iQuotesWso2Service: IQuotesWso2Service,
    private _iNegotiationApiService: INegotiationApiService,
    private _iNegotiationWso2Service: INegotiationWso2Service,
    private _iNewsWso2Service: INewsWso2Service,
    private _iNewsApiService: INewsApiService,
    private _iDifusionWso2Service: IDifusionWso2Service,
    private _iDifusionApiService: IDifusionApiService,
    private _iCdroServicesApiService: ICedroServicesApiService,
    private _iCdroServicesWso2Service: ICedroServicesWso2Service,
    private _iSuitabilityWso2Service: ISuitabilityWso2Service,
    private _iSuitabilityApiService: ISuitabilityApiService,
    private _iSuitabilityAdapterService: ISuitabilityAdapterService,
    private _iEletronicSignatureWso2Service: IEletronicSignatureWso2Service,
    private _iEletronicSignatureApiService: IEletronicSignatureApiService,
    private _iEletronicSignatureAdapterService: IEletronicSignatureAdapterService,
    private _iEmailFacadeService: IEmailFacadeService,
    private _iEmailAdapterService: IEmailAdapterService,
    private _iEmailWso2Service: IEmailWso2Service,
  ) {

    if (this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginIAM) {
      this.iQuote = this._iQuotesWso2Service;
      this.iNegotiation = this._iNegotiationWso2Service;
      this.iNews = this._iNewsWso2Service;
      this.iDifusion = this._iDifusionWso2Service;
      this.iCedroServices = this._iCdroServicesWso2Service;
      this.iSuitabilityService = this._iSuitabilityAdapterService;
      this.iEletronicSignature = this._iEletronicSignatureAdapterService;
      this.iEmailServices = this._iEmailWso2Service;
    }else if (this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginW) {
      this.iQuote = this._iQuotesWso2Service;
      this.iNegotiation = this._iNegotiationWso2Service;
      this.iNews = this._iNewsWso2Service;
      this.iDifusion = this._iDifusionWso2Service;
      this.iCedroServices = this._iCdroServicesWso2Service;
      this.iSuitabilityService = this._iSuitabilityWso2Service;
      this.iEletronicSignature = this._iEletronicSignatureWso2Service;
      this.iEmailServices = this._iEmailWso2Service;
    } else if (this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA) {
      this.iQuote = this._iQuotesWso2Service;
      this.iNegotiation = this._iNegotiationWso2Service;
      this.iNews = this._iNewsWso2Service;
      this.iDifusion = this._iDifusionWso2Service;
      this.iCedroServices = this._iCdroServicesWso2Service;
      this.iSuitabilityService = this._iSuitabilityAdapterService;
      this.iEletronicSignature = this._iEletronicSignatureAdapterService;
      this.iEmailServices = this._iEmailAdapterService;
    } else if (this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginS
      || this._configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginO) {
      this.iQuote = this._iQuotesApiService;
      this.iNegotiation = this._iNegotiationApiService;
      this.iNews = this._iNewsApiService;
      this.iDifusion = this._iDifusionApiService;
      this.iCedroServices = this._iCdroServicesApiService;
      this.iSuitabilityService = this._iSuitabilityApiService;
      this.iEletronicSignature = this._iEletronicSignatureApiService;
      this.iEmailServices = this._iEmailFacadeService;
    } else {
      this._configService.redirectExpireSession(Constants.ERROR_SYSTEM_TEXT);
    }
  }
}
